import React from 'react';

function BusIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" fill="none" viewBox="0 0 29 28">
      <path
        stroke="#0AB7F1"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M5.167 19.833a2.333 2.333 0 104.666 0 2.333 2.333 0 00-4.667 0zm14 0a2.333 2.333 0 104.665 0 2.333 2.333 0 00-4.666 0z"
      ></path>
      <path
        stroke="#0AB7F1"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M5.167 19.833H2.833V7A1.167 1.167 0 014 5.833h16.333c1.547 0 3.031.86 4.125 2.392 1.094 1.532 1.709 3.61 1.709 5.775v5.833h-2.334m-4.666 0H9.833"
      ></path>
      <path
        stroke="#0AB7F1"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M19.167 5.833L20.917 14h5.25M2.833 11.667h17.5M8.667 5.833v5.834M14.5 5.833v5.834"
      ></path>
    </svg>
  );
}

export default BusIcon;
